export default __webpack_public_path__ + "static/media/Edit.2592be30.svg";